import { isNumber, isNullOrUndefinedOrEmpty } from "base/utils";
import { messages } from "base/constans";

export const validateIsRequired = (val) => {
  let isExists = !isNullOrUndefinedOrEmpty(val);
  return isExists ? isExists : "Is required";
};

export const validatePercentage = (item, errorMessageField) => {
  let errorMessage = null;
  let isNum = isNumber(parseInt(item.percentage));

  if (!isNum) errorMessage = messages.numbersOnly;
  let isPercent = item.percentage > -1 && item.percentage < 101;
  if (!isPercent)
    errorMessage =
      item.percentage > -1
        ? messages.lessThanHundred
        : messages.noNegativeNumbers;
  item[errorMessageField] = errorMessage;
};

export const validatePositiveNumber = (item, field) => {
  if (!item) return;
  let errorMessage = null;
  let isNum = false;
  let isNegative = false;
  if (typeof item == "object") {
    isNum = isNumber(parseInt(item[field]));
    isNegative = item[field] < 0;

    if (!isNum) errorMessage = messages.numbersOnly;
    if (isNegative) errorMessage = messages.noNegativeNumbers;
    item['errorMessage'] = errorMessage;
  }
  if (typeof item == "number" || typeof item == "string") {
    isNum = isNumber(parseInt(item));
    isNegative = item < 0;

    if (!isNum) errorMessage = messages.numbersOnly;
    if (isNegative) errorMessage = messages.noNegativeNumbers;
  }
  if (errorMessage) return errorMessage;
  else return true;
};
